import { render } from "./draftOrder.vue?vue&type=template&id=50e96adb"
import script from "./draftOrder.vue?vue&type=script&lang=js"
export * from "./draftOrder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__